export default {
  orders: [],
  deliveryAddresses: [],
  deliveryCompanies: [],
  currentOrder: null,
  warehouseOrdersCount: 0,
  rxOrdersCount: 0,
  warehouseItemsCount: 0,
  rxItemsCount: 0,
  frameColoring: {},
  createGlassesDetails: {},
  currentTab: 'warehouse'
}
